import { z } from "zod";

export const getUpdateContractSchema = () =>
  z.object({
    ordersFromDate: z.string().optional(),
    phoneService: z.boolean(),
  });
